import { applyStyle } from '../css';
const PADDING = {
    sm: '6px 12px',
    md: '10px 18px',
    lg: '12px 22px',
};
const FONTSIZE = {
    sm: 'var(--fs-caption)',
    md: 'var(--fs-body)',
    lg: 'var(--fs-h3)',
};
function variantStyle(v) {
    switch (v) {
        case 'primary':
            return {
                bg: 'var(--accent)',
                color: 'var(--on-accent)',
                border: '1px solid var(--accent)',
                hoverBg: 'var(--accent-hover)',
            };
        case 'ghost':
            return {
                bg: 'transparent',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-strong)',
                hoverBg: 'var(--bg-elev-3)',
            };
        case 'danger':
            return {
                bg: 'var(--status-error)',
                color: '#fff',
                border: '1px solid var(--status-error)',
                hoverBg: '#dc2626',
            };
        case 'secondary':
            return {
                bg: 'var(--bg-elev-3)',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-strong)',
                hoverBg: 'var(--border-strong)',
            };
        case 'subtle':
            return {
                bg: 'transparent',
                color: 'var(--text-secondary)',
                border: '1px solid transparent',
                hoverBg: 'var(--bg-elev-3)',
            };
    }
}
export function createButton(opts) {
    const variant = opts.variant ?? 'primary';
    const size = opts.size ?? 'md';
    const v = variantStyle(variant);
    const btn = document.createElement('button');
    btn.type = 'button';
    if (opts.disabled)
        btn.disabled = true;
    const inner = [];
    if (opts.iconHtml && !opts.iconRight)
        inner.push(opts.iconHtml);
    inner.push(`<span>${escapeHtml(opts.label)}</span>`);
    if (opts.iconHtml && opts.iconRight)
        inner.push(opts.iconHtml);
    btn.innerHTML = inner.join('');
    applyStyle(btn, {
        display: opts.fullWidth ? 'flex' : 'inline-flex',
        width: opts.fullWidth ? '100%' : 'auto',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--sp-2)',
        padding: PADDING[size],
        fontSize: FONTSIZE[size],
        fontWeight: '500',
        fontFamily: 'inherit',
        background: v.bg,
        color: v.color,
        border: v.border,
        borderRadius: 'var(--radius-sm)',
        cursor: opts.disabled ? 'not-allowed' : 'pointer',
        opacity: opts.disabled ? '0.55' : '1',
        transition: 'background var(--motion-fast), border-color var(--motion-fast), transform var(--motion-fast)',
        whiteSpace: 'nowrap',
    });
    btn.addEventListener('mouseenter', () => {
        if (btn.disabled)
            return;
        btn.style.background = v.hoverBg;
    });
    btn.addEventListener('mouseleave', () => {
        if (btn.disabled)
            return;
        btn.style.background = v.bg;
    });
    if (opts.attrs)
        for (const [k, val] of Object.entries(opts.attrs))
            btn.setAttribute(k, val);
    if (opts.onClick)
        btn.addEventListener('click', opts.onClick);
    return btn;
}
function escapeHtml(s) {
    return s.replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
}
